class CollectionCategorySlider extends HTMLElement {
    constructor() {
        super();
        this.slider = this;
        this.initSlider();
    }

    initSlider() {
        new Swiper(this.slider, {
            slidesPerView: 1.5,
            grabCursor: true,
            spaceBetween: 10,
            pagination: {
                el: this.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                1440: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                },
            },

        });
    }
}

customElements.define('collection-category-slider', CollectionCategorySlider);

console.log("Category Slider Loaded");
